import styled from "styled-components";

export const PageLoader = styled.div`
  margin: auto;
`;
